import { requests } from "../services/request";

export async function getMethod(url, payload) {
  return await requests.getRequest(url, payload);
}
export async function postMethod(url, payload) {
  return await requests.postRequest(url, payload); 
}